import { Injectable, Type } from "@angular/core";
import { NgbModalRef } from "@ng-bootstrap/ng-bootstrap";

@Injectable({
    providedIn: "root"
})
export class ModalComponentMediator {
    typ: Type<any>;
    ref: NgbModalRef;

    setType(typ: Type<any>) {
        this.typ = typ;
    }

    setRef(ref: NgbModalRef) {
        this.ref = ref;
    }

    getType(): Type<any> {
        return this.typ;
    }

    getRef(): NgbModalRef {
        return this.ref;
    }
}
